import { Component, Signal, computed, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { CsIconModule } from '@components/icon';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { DeliveryEstimateStripComponent } from '@components/delivery-estimate-strip/delivery-estimate-strip.component';
import { AddressAutofillService, DetectedLocation, DetectionState } from '../services/address-autofill.service';

export enum LocationSheetResult { Confirm = 'confirm', Edit = 'edit' }

@Component({
  selector: 'app-address-location-sheet',
  templateUrl: './address-location-sheet.component.html',
  imports: [ButtonCtaComponent, CsIconModule, DeliveryEstimateStripComponent],
})
export class AddressLocationSheetComponent {
  private readonly sheetRef: MatBottomSheetRef = inject(MatBottomSheetRef);
  protected readonly autofill: AddressAutofillService = inject(AddressAutofillService);

  protected readonly isDetected: Signal<boolean> = computed((): boolean => this.autofill.state() === DetectionState.Detected);
  protected readonly location: Signal<DetectedLocation | null> = this.autofill.location;
  protected readonly cityLine: Signal<string> = computed((): string => {
    const location = this.location();
    return [location?.city, location?.state].filter(Boolean).join(', ');
  });

  protected confirm(): void {
    this.sheetRef.dismiss(LocationSheetResult.Confirm);
  }

  protected edit(): void {
    this.sheetRef.dismiss(LocationSheetResult.Edit);
  }

  async handleBackPress(): Promise<boolean> {
    this.sheetRef.dismiss();
    return true;
  }
}
